import { 
    apiRequest,
    cutiList,
    cutiTypeList,
    signatoriesList,
    cutiInactive,
    cutiDetail,
    cutiApproval,
    cutiCancelAdmin
} from '../../../../../../services/adapters/kepegawaian/cutiService'

class IndexRepository {

    fetchRowTable = async (query, cancelToken) => {
        return await apiRequest("get", cutiList, {
            cancelToken: cancelToken,
            params: query
        }, true)
    }

    fetchInactive = async (query) => {
        return await apiRequest("post", cutiInactive, {
            body: query
        }, true)
    }

    fetchTypeList = async (query, cancelToken) => {
        return await apiRequest("get", cutiTypeList, {
            cancelToken: cancelToken,
            params: query
        }, true)
    }

    fetchSignatoriesList = async (query, cancelToken) => {
        return await apiRequest("get", signatoriesList, {
            cancelToken: cancelToken,
            params: query
        }, true)
    }

    fetchDetail = async (query, cancelToken) => {
        return await apiRequest("get", cutiDetail, {
            cancelToken: cancelToken,
            params: query
        }, true)
    }

    fetchApproval = async (query, cancelToken) => {
        return await apiRequest("post", cutiApproval, {
            body: query
        }, true)
    }

    fetchCancelAdmin = async (query) => {
        return await apiRequest("post", cutiCancelAdmin, {
            body: query
        }, true)
    }

}

export default IndexRepository